import { Inject, Injectable, Optional } from "@angular/core";
import {
	HttpClient,
	HttpHeaders,
	HttpParams,
	HttpResponse,
	HttpEvent,
} from "@angular/common/http";

// import { ResponseContentType } from '@angular/common/http';

import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

import { Observable } from "rxjs";

import {
	DbService,
	Configuration,
	ConfigurationParameters,
	BASE_PATH,
} from "papi-client-ng2";

// import { CustomHttpUrlEncodingCodec } from 'papi-client-ng2/encoder';
import { HttpUrlEncodingCodec } from "@angular/common/http";
import { environment } from "environments/environment";

/**
 * CustomHttpUrlEncodingCodec
 * Fix plus sign (+) not encoding, so sent as blank space
 * See: https://github.com/angular/angular/issues/11058#issuecomment-247367318
 */
export class CustomHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
	constructor() {
		super();
	}
	
	encodeKey(k: string): string {
		k = super.encodeKey(k);
		return k.replace(/\+/gi, "%2B");
	}
	encodeValue(v: string): string {
		v = super.encodeValue(v);
		return v.replace(/\+/gi, "%2B");
	}
}

@Injectable()
export class PapiDbService extends DbService {
	constructor(
		protected httpClient: HttpClient,
		basePath: string,
		configuration: Configuration
	) {
		super(httpClient, basePath, configuration);
	}
	/**
	 *
	 * Get a floorplan as a blob.
	 * @param id ID of the Floorplan instance.
	 * @param attachment True to download the image.
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public getFloorplanFileAsBlob(
		id: number,
		attachment?: boolean,
		observe?: "body",
		reportProgress: boolean = false
	): Observable<Blob> {
		if (id === null || id === undefined) {
			throw new Error(
				"Required parameter id was null or undefined when calling getFloorplanFile."
			);
		}

		let queryParameters = new HttpParams({
			encoder: new CustomHttpUrlEncodingCodec(),
		});
		if (attachment !== undefined) {
			queryParameters = queryParameters.set(
				"attachment",
				<any>attachment
			);
		}

		let headers = this.defaultHeaders;

		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"]
			);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = ["image/png", "image/svg+xml"];
		let httpHeaderAcceptSelected: string | undefined =
			this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		let consumes: string[] = [
			"application/json",
			"application/x-www-form-urlencoded",
		];

		return this.httpClient.get(
			`${this.basePath}/db/Floorplan/${encodeURIComponent(
				String(id)
			)}/file`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress,
				responseType: "blob",
			}
		);
	}
	public createRoomByFloorPlan(createRoomFormData : FormData): Observable<any> {
		let apiUrl = environment.TEZZ_ADD_PAPI_PATH + '/room-geometry/';
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],

			);
		}
		// to determine the Content-Type header
		let consumes: string[] = [
			"application/json",
			"application/x-www-form-urlencoded",
		];
		let httpHeaderAcceptSelected: string | undefined =
			this.configuration.selectHeaderAccept(consumes);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.post(apiUrl, createRoomFormData, { headers });
	}

	public createRoomsWithAI(createRoomFormData : FormData): Observable<any> {
		let apiUrl = environment.TEZZ_ADD_PAPI_PATH + '/process-pdf/';
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],

			);
		}
		// to determine the Content-Type header
		let consumes: string[] = [
			"application/json",
			"application/x-www-form-urlencoded",
		];
		let httpHeaderAcceptSelected: string | undefined =
			this.configuration.selectHeaderAccept(consumes);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.post(apiUrl, createRoomFormData, { headers });
	}

	getCampusBuildings(
		organizationId: any,
		campusId: number
	): Observable<any> {
		const getCampusBuildingsUrl = '/campus/get-buildings/';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + getCampusBuildingsUrl;
		let headers = this.defaultHeaders;
			// authentication (JWT) required
			if (this.configuration.apiKeys["Authorization"]) {
				headers = headers.set(
					"Authorization",
					this.configuration.apiKeys["Authorization"],


				);
			}
		const body = {
		organizationIds: organizationId,
		campusId: campusId
		};

		return this.httpClient.post(apiUrl, body, { headers });
	}

	addCampusBuildings(
		organizationId: string,
		perimeterId: number,
		buildingId: number
	): Observable<any> {
		const addCampusBuildingsUrl = '/campus/add-building/';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + addCampusBuildingsUrl;
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],

			);
		}
		const body = {
			organization_id: organizationId,
			campus_id: perimeterId,
			perimeter_id: buildingId
		};

		return this.httpClient.post(apiUrl, body, { headers });
	}

	viewCampusBuildings(
		organizationId: string,
		perimeterId: number
	): Observable<any> {
		const viewCampusBuildingsUrl = '/campus/view-buildings/';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + viewCampusBuildingsUrl;
		let headers = this.defaultHeaders;
			// authentication (JWT) required
			if (this.configuration.apiKeys["Authorization"]) {
				headers = headers.set(
					"Authorization",
					this.configuration.apiKeys["Authorization"],

				);
			}
		const body = {
		organization_id: organizationId,
		campus_id: perimeterId
		};

		return this.httpClient.post(apiUrl, body,{ headers });
	}

	listCampusBuildings(payload: {
		id: any;
		perimeter_id: any;
		label: any;
		address: any;
		type: string;
		limit: number;
		offset: number;
	}): Observable<any> {
		const listCampusBuildingsUrl = '/campus/get-building-details';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + listCampusBuildingsUrl;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
				headers = headers.set(
					"Authorization",
					this.configuration.apiKeys["Authorization"],

				);
			}

		return this.httpClient.post(apiUrl, payload, { headers });
	}

	deleteCampusBuilding(
		organizationId: number,
		perimeterId: number,
		campusId: number
	): Observable<any> {

		const deleteCampusBuildingUrl = '/campus/building-delete/';
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + deleteCampusBuildingUrl;

		let headers = this.defaultHeaders;

		// authentication (JWT) required
		if (this.configuration.apiKeys['Authorization']) {
			headers = headers.set(
				'Authorization',
				this.configuration.apiKeys["Authorization"],
			);
		}

		const body = {
			organization_id: organizationId,
			perimeter_id: perimeterId,
			campus_id: campusId
		};

		return this.httpClient.delete(apiUrl, {
			headers,
			body
		});
	}

	updateCampusBuildings(
		campusId: number,
		buildingIds: number[]
	): Observable<any> {
		const updateCampusBuildingsUrl = `/campus/${campusId}/buildings/update/`;
		const apiUrl = environment.TEZZ_ADD_PAPI_PATH + updateCampusBuildingsUrl;

		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],
			);
		}

		const body = {
			ids: buildingIds
		};

		return this.httpClient.patch(apiUrl, body, { headers });
	}

	getCampusRoles(): Observable<any> {
		const getCampusRoles = '/db/Action/getCampusRoles';
		const apiUrl = environment.PAPI_BASE_PATH + getCampusRoles;
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set(
				"Authorization",
				this.configuration.apiKeys["Authorization"],
			);
		}

		return this.httpClient.post(apiUrl, {}, { headers });
	}

	getMaterialTypes(limit: number = 100): Observable<any> {
		const MaterialTypePath = '/db/MaterialType/findAndCountAll';
		const apiUrl = `${environment.PAPI_BASE_PATH}${MaterialTypePath}`;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		const body = {
			"order": [["id", "DESC"]]
		}

		return this.httpClient.post(apiUrl, body, { headers });
	}

	public exportDirectGlb(buildingData: any, buildingName?: string, scale?: number, material_type?: string, material_id?: any): Observable<any> {
		const apiUrl = `${this.basePath}/api/export/direct-glb-files`;
		let headers = this.defaultHeaders;
		// authentication (JWT) required
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		const body: any = {
			buildingData,
			buildingName,
			scale,
			material_type,
			material_id
		};
		// Remove undefined fields
		Object.keys(body).forEach(k => body[k] === undefined && delete body[k]);
		return this.httpClient.post(apiUrl, body, { headers });
	}

	setPerimeterGlb(perimeterId: number, materialId: any): Observable<any> {
		const apiUrl = `${this.basePath}/db/Perimeter/PerimeterGlbMaterialId`;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}

		const body = {
			perimeterId: perimeterId,
			materialId: materialId
		};

		return this.httpClient.post(apiUrl, body, { headers });
	}

	triggerGlbExport(perimeterId: number): Observable<any> {
		const apiUrl = `${this.basePath}/db/Perimeter/TriggerGlbExport`;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}

		const body = {
			perimeterId: perimeterId
		};

		return this.httpClient.post(apiUrl, body, { headers });
	}

	getPerimeterGlb(perimeterId: number): Observable<any> {
		const apiUrl = `${this.basePath}/db/Perimeter/PerimeterGlb`;
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}

		let body = {
			perimeterId: perimeterId.toString(),
		}
		
	
		return this.httpClient.post(apiUrl, body, { headers });
	}

	public createRaspberryPi(body: RaspberryPiCreate, observe: 'body' = 'body', reportProgress: boolean = false): Observable<RaspberryPi> {
		if (body === null || body === undefined) {
			throw new Error('Required parameter body was null or undefined when calling createRaspberryPi.');
		}
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let consumes: string[] = ['application/json', 'application/x-www-form-urlencoded'];
		let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected !== undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.post<RaspberryPi>(`${this.basePath}/db/RaspberryPi/create`, body, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}

	public updateRaspberryPi(id: number, body: RaspberryPi, observe: 'body' = 'body', reportProgress: boolean = false): Observable<RaspberryPi> {
		if (id === null || id === undefined) {
			throw new Error('Required parameter id was null or undefined when calling updateRaspberryPi.');
		}
		if (body === null || body === undefined) {
			throw new Error('Required parameter body was null or undefined when calling updateRaspberryPi.');
		}
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let consumes: string[] = ['application/json', 'application/x-www-form-urlencoded'];
		let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected !== undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.patch<RaspberryPi>(`${this.basePath}/db/RaspberryPi/${encodeURIComponent(String(id))}`, body, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}

	public deleteRaspberryPi(id: number, observe: 'body' = 'body', reportProgress: boolean = false): Observable<any> {
		if (id === null || id === undefined) {
			throw new Error('Required parameter id was null or undefined when calling deleteRaspberryPi.');
		}
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.delete(`${this.basePath}/db/RaspberryPi/${encodeURIComponent(String(id))}`, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}

	public findRaspberryPi(body?: RaspberryPiSearch, observe: 'body' = 'body', reportProgress: boolean = false): Observable<RaspberryPiFind> {
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let consumes: string[] = ['application/json', 'application/x-www-form-urlencoded'];
		let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected !== undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.post<RaspberryPiFind>(`${this.basePath}/db/RaspberryPi/findAndCountAll`, body || {}, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}

	public getRaspberryPi(id: number, observe: 'body' = 'body', reportProgress: boolean = false): Observable<RaspberryPi> {
		if (id === null || id === undefined) {
			throw new Error('Required parameter id was null or undefined when calling getRaspberryPi.');
		}
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.get<RaspberryPi>(`${this.basePath}/db/RaspberryPi/${encodeURIComponent(String(id))}`, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}

	public findKillSwitch(body?: KillSwitchSearch, observe: 'body' = 'body', reportProgress: boolean = false): Observable<KillSwitchFind> {
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let consumes: string[] = ['application/json', 'application/x-www-form-urlencoded'];
		let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected !== undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.post<KillSwitchFind>(`${this.basePath}/db/KillSwitch/findAndCountAll`, body || {}, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}

	public getKillSwitch(id: number, observe: 'body' = 'body', reportProgress: boolean = false): Observable<KillSwitch> {
		if (id === null || id === undefined) {
			throw new Error('Required parameter id was null or undefined when calling getKillSwitch.');
		}
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.get<KillSwitch>(`${this.basePath}/db/KillSwitch/${encodeURIComponent(String(id))}`, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}

	public createKillSwitch(body: KillSwitchCreate, observe: 'body' = 'body', reportProgress: boolean = false): Observable<KillSwitch> {
		if (body === null || body === undefined) {
			throw new Error('Required parameter body was null or undefined when calling createKillSwitch.');
		}
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let consumes: string[] = ['application/json', 'application/x-www-form-urlencoded'];
		let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected !== undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.post<KillSwitch>(`${this.basePath}/db/KillSwitch`, body, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}

	public updateKillSwitch(id: number, body: KillSwitch, observe: 'body' = 'body', reportProgress: boolean = false): Observable<KillSwitch> {
		if (id === null || id === undefined) {
			throw new Error('Required parameter id was null or undefined when calling updateKillSwitch.');
		}
		if (body === null || body === undefined) {
			throw new Error('Required parameter body was null or undefined when calling updateKillSwitch.');
		}
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let consumes: string[] = ['application/json', 'application/x-www-form-urlencoded'];
		let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected !== undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.patch<KillSwitch>(`${this.basePath}/db/KillSwitch/${encodeURIComponent(String(id))}`, body, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}

	public deleteKillSwitch(id: number, observe: 'body' = 'body', reportProgress: boolean = false): Observable<any> {
		if (id === null || id === undefined) {
			throw new Error('Required parameter id was null or undefined when calling deleteKillSwitch.');
		}
		let headers = this.defaultHeaders;
		if (this.configuration.apiKeys["Authorization"]) {
			headers = headers.set("Authorization", this.configuration.apiKeys["Authorization"]);
		}
		let httpHeaderAccepts: string[] = ['application/json'];
		let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected !== undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}
		return this.httpClient.delete(`${this.basePath}/db/KillSwitch/${encodeURIComponent(String(id))}`, {
			withCredentials: this.configuration.withCredentials,
			headers: headers,
			observe: observe,
			reportProgress: reportProgress
		});
	}
}

export interface RaspberryPi {
	id?: number;
	sensorId?: number;
	uuid?: string;
	createdAt?: Date;
	updatedAt?: Date;
	deletedAt?: Date;
}

export interface RaspberryPiCreate {
	sensorId: number;
	uuid?: string;
}

export interface RaspberryPiSearch {
	attributes?: Array<string>;
	where?: any;
	order?: Array<Array<string>>;
	limit?: number;
	offset?: number;
}

export interface RaspberryPiFind {
	count?: number;
	rows?: Array<RaspberryPi>;
}

export interface KillSwitch {
	id?: number;
	userId?: number;
	name?: string;
	checkEnabled?: boolean;
	createdAt?: Date;
	updatedAt?: Date;
	deletedAt?: Date;
}

export interface KillSwitchCreate {
	userId?: number;
	name: string;
	checkEnabled?: boolean;
}

export interface KillSwitchSearch {
	attributes?: Array<string>;
	where?: any;
	order?: Array<Array<string>>;
	limit?: number;
	offset?: number;
}

export interface KillSwitchFind {
	count?: number;
	rows?: Array<KillSwitch>;
}


